export const headers = [
  {
    field: "codigo_subrubro",
    headerName: "Codigo",
    width: 90
  },
  {
    field: "descripcion_subrubro",
    headerName: "Descripcion",
    width: 230
  },
  {
    field: "descripcionRamo",
    headerName: "Ramo",
    width: 130
  },
  {
    field: "descripcionRubro",
    headerName: "Rubro",
    width: 130
  },
  
    { field: "web", headerName: "Web", width: 10 },
    { field: "app", headerName: "App", width: 10 },
];